var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal"},[_c('div',{ref:"modalBox",staticClass:"modal-content",style:(_vm.custom)})])
}
var staticRenderFns = []

export { render, staticRenderFns }